// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ChatAIIcon = registerClientReference(
    function() { throw new Error("Attempted to call ChatAIIcon() from the server but ChatAIIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "ChatAIIcon",
);
export const CheckCircle2Icon = registerClientReference(
    function() { throw new Error("Attempted to call CheckCircle2Icon() from the server but CheckCircle2Icon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "CheckCircle2Icon",
);
export const PaperclipIcon = registerClientReference(
    function() { throw new Error("Attempted to call PaperclipIcon() from the server but PaperclipIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "PaperclipIcon",
);
export const SendIcon = registerClientReference(
    function() { throw new Error("Attempted to call SendIcon() from the server but SendIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "SendIcon",
);
export const SparklesIcon = registerClientReference(
    function() { throw new Error("Attempted to call SparklesIcon() from the server but SparklesIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "SparklesIcon",
);
export const UploadIcon = registerClientReference(
    function() { throw new Error("Attempted to call UploadIcon() from the server but UploadIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "UploadIcon",
);
export const XIcon = registerClientReference(
    function() { throw new Error("Attempted to call XIcon() from the server but XIcon is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/chatbot/chatbot-icons.tsx",
    "XIcon",
);
